import { render } from "./LicenceAcceptanceScreen.vue?vue&type=template&id=e0ae5068&scoped=true"
import script from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"
export * from "./LicenceAcceptanceScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=e0ae5068&lang=scss&scoped=true"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ae5068"]])

export default __exports__